import React, { Component } from 'react';
import {Link } from 'react-router-dom';
import LoadMask from "../LoadMask/LoadMask";
import ImageVer from '../../../../../assets/img/icons/Ver.png';
import { RenderDateTime } from "../../Utils/renderField/renderTableField";
export default class CardPMEnviadas extends Component {
    render() {
        const { data, loader } = this.props;
        return (
            <div className="">
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <h5 className="t-primary">{ data.length > 0 ? this.props.titulo: ""}</h5>
                    <div className="row d-flex justify-content-center">
                            <div className="row col-12 d-flex justify-content-around">
                                {
                                    data.map((item,index)=>{
                                        return(
                                            <div
                                                key={index}
                                                className="card col-lg-3 col-md-4 col-sm-6 col-12 row pmcard"
                                            >
                                                <div className="col-12">
                                                    <span style={{color:"#f3a631"}} >Fecha:</span>
                                                    <span><RenderDateTime fecha={item.fecha} /></span><br/>
                                                    <span style={{color:"#f3a631"}}>Emitida por:</span><br/>
                                                    <span>{item.emitido_por? item.emitido_por.first_name:'----'}</span><br/>
                                                    <span style={{color:"#f3a631"}}>No. orden:</span><br/>
                                                    <span>{item.no_orden}</span><br/>
                                                    <span style={{color:"#f3a631"}}>Empresa:</span>
                                                    <span>{item.nombre_empresa}</span>
                                                </div>
                                                {this.props.link && (<div className="pmicon">
                                                    <Link to={`${this.props.link}/${item.id}/detalle`} className="" >
                                                        <img className="action-img-ver" title="ver" src={ImageVer} alt="ver" />
                                                    </Link>
                                                </div>)}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                    </div>
                </LoadMask>
            </div>
        );
    }
}
